import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import DeleteIcon from "@material-ui/icons/Delete"
import { eliminarWalletDocuemntoAction, obtenrWalletPaqueteAction } from "./../../../ducks/clientesDuck"
import { useState } from "react"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
import { DialogMessage } from "../../../global/DialogMessage"

const ButtonDelete = (props) => {
    const { idDocumento, Nombre, idPaquete } = props
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const onDelete = () => {
        DialogMessage.fire({
            title: `¿Está seguro de que desea eliminar el archivo ${Nombre}?`,
            text: 'Se eliminara de forma permanente',
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(eliminarWalletDocuemntoAction({ idDocumento: idDocumento })).then(Response => {
                    if (Response.status || Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        setLoad(false)
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                    dispatch(obtenrWalletPaqueteAction({ idPaquete }))
                    setLoad(false)
                })
            }
        })
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={onDelete} >
                <DeleteIcon />
            </IconButton>
            <BackDrop open={load} />
        </div>

    )
}
export default ButtonDelete